import { Dropdown, Input, InputGroup } from "@citi-icg-172888/icgds-react";
import { useState, useRef, forwardRef, useEffect } from "react";

import { countrycodelist } from "../services/constants/InitialConstants";

interface PhoneComponentI {
  updateCountry: any;
  updatePhone: any;
  countryCd?: string;
  mobileNum?: string;
  maxLength?: number;
  initialMobileNumber?: string;
  disableFields?: boolean;
  error?: string;
  id?: string;
  ariaDescribedBy?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PhoneComponent = forwardRef<HTMLDivElement, PhoneComponentI>(
  (
    {
      updateCountry,
      updatePhone,
      countryCd,
      mobileNum,
      maxLength = 40,
      disableFields = false,
      error,
      id,
      ariaDescribedBy = "",
    }: PhoneComponentI,
    ref
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultLabel = "+1";
    const [label, setLabel] = useState(countryCd);
    const [filteredText] = useState<any[]>(countrycodelist);
    const [mobileNumber, setMobileNumber] = useState<number | string>(mobileNum || "");
    const [countryCode, setCountryCode] = useState<number | string>(countryCd || "");
    const inputRef = useRef<HTMLInputElement>(null);
    const phoneNumbrRef = useRef<HTMLInputElement>(null);
    const onCountryPrefixChange = (selectedValue: string | string[]) => {
      if (selectedValue) {
        let selectedItem: any[] = [];

        if (countrycodelist) {
          selectedItem = countrycodelist.filter((item: any) => {
            return item.dial_code_label === selectedValue;
          });
        }
        const [item] = selectedItem;
        setCountryCode(item.dial_code_label);
        updateCountry(item.dial_code_label);
        if (item) {
          setLabel(`${item.dial_code_label}`);
          updatePhone(`${mobileNumber ? mobileNumber : ""}`.substring(0, maxLength));
        }
      } else {
        setLabel(defaultLabel);
        updatePhone(`${mobileNumber ? mobileNumber : ""}`);
      }
      phoneNumbrRef.current?.focus();
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onPhoneNumberChange = (e: any) => {
      // if phone number output is configured as number, we need to remove all non-numeric characters from string
      let numericValue = e.target.value ? e.target.value.replace(/[^0-9.]/g, "") : "";
      // prevent NaN / 0, if user didn't enter any numeric character
      numericValue = numericValue.trim() !== "" ? Number(numericValue) : "";

      // for input type = text, restrict non numeric characters
      // regex for only numeric
      const regexp = /^[0-9\b]+$/;

      // if value is not blank, then test the regex
      if (e.target.value === "" || regexp.test(e.target.value)) {
        setMobileNumber(numericValue);
        updatePhone(`${numericValue}`);
      } else {
        updatePhone("");
        return;
      }
    };

    const handleClick = () => {
      const rect = inputRef.current?.getBoundingClientRect();
      if (rect && window.parent.location.href.includes("contact-us")) {
        window.scrollTo({
          top: rect.top,
          behavior: "smooth",
        });
      }
      inputRef.current?.focus();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onKeyDown = (e: any) => {
      const keyCode = e.nativeEvent.keyCode;
      if (keyCode === 69 || keyCode === 187 || keyCode === 190) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current?.focus();
      }
    }, [inputRef.current]);

    return (
      <div onClick={handleClick} onKeyDown={handleClick} id="phone_number">
        <InputGroup
          ref={ref}
          addonBefore={
            <Dropdown
              label={label}
              pureMenu
              style={{ height: "12px !important" }}
              disabled={disableFields}
              onChange={(e) => onCountryPrefixChange(e)}
              popupClass="lmn-ui-lg"
              data-cv-tracking-id="dropdown-tracking-id"
              aria-label="Country Code"
              value={countryCode}
            >
              {filteredText &&
                filteredText.map((item: any, index: any) => {
                  return (
                    <Dropdown.Item
                      key={item.value + "" + index}
                      value={item.dial_code_label}
                      data-cv-tracking-id={`dropdown-item${index}-tracking-id`}
                    >
                      {item.dial_code_label} {item.label}
                    </Dropdown.Item>
                  );
                })}
            </Dropdown>
          }
        >
          <Input
            id={id}
            aria-label="Phone Number"
            type="text"
            size="md"
            ref={phoneNumbrRef}
            maxLength={15}
            value={mobileNumber}
            disabled={disableFields}
            onChange={(e) => onPhoneNumberChange(e)}
            onKeyDown={onKeyDown}
            invalid={!!error}
            aria-describedby={ariaDescribedBy ? ariaDescribedBy : ""}
          />
        </InputGroup>
      </div>
    );
  }
);

export default PhoneComponent;
